
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkEventInvitationDeclinedStatusEnum } from '../models/work-event-invitation-declined-status-enum';
import { WorkEventInvitationExamResultEnum } from '../models/work-event-invitation-exam-result-enum';

export function getUpdateEventInvitationOrganisatorDtoFormGroup() {
return new FormGroup({
    declinedStatus: new FormControl<WorkEventInvitationDeclinedStatusEnum | undefined>(undefined),
    examResult: new FormControl<WorkEventInvitationExamResultEnum | undefined>(undefined),
})
;
}
      